import { OnInit, OnDestroy } from "@angular/core";
import { SidebarService } from "@ibe/services/ui";
import { ActivatedRoute, Router } from "@angular/router";
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { INDRAIbeAdminService } from "@ibe.services/ibeadmin.indra.service";
import { ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, ANCILLARY_GROUP_FAST_TRACK_LIST, TRANSLATION_ANCILLARY_GROUP, BRAND_DESCRIPTION_EXECUTIVE, BRAND_DESCRIPTION_TOP_EXECUTIVE, SSR_CODE_FAST_TRACK, ANCILLARY_GROUP_DEPORTEES_LIST, ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST, SSR_CODE_UNACCOMPANIED_MINOR, EXTRAS_ANCILLARY_FAST_TRACK, EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS, BRAND_NAMES_MAP, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from "@ibe.config";
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { INDRAAncillariesShoppingCartService } from "@ibe.services/ancillaries-shopping-cart.indra.service";
import { INDRATotalSummaryService } from "@ibe.services/total-summary.service";
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
var INDRADetailsFastTrackComponent = /** @class */ (function () {
    function INDRADetailsFastTrackComponent(sidebarService, route, router, bookingService, ibeAdminService, bfmDataStorage, ancillaryCartService, totalSummaryService, bookingSearchService, ibeAdminConfigService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.bookingService = bookingService;
        this.ibeAdminService = ibeAdminService;
        this.bfmDataStorage = bfmDataStorage;
        this.ancillaryCartService = ancillaryCartService;
        this.totalSummaryService = totalSummaryService;
        this.bookingSearchService = bookingSearchService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.passengers = [];
        this.paxFareInfoFeatures = [];
        this.paxPurchaseFeatures = [];
        this.paxTierBenefits = [];
        // hasLayover = false;
        this.countUnit = '';
        this.showAdd = true;
        this.directFlight = false;
        this.stops = [];
        this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.';
        this.LOCAL_TRANSLATION_DETAILED_FASTTRACK = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsFastTrack.';
        this.hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
        this.hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
        this.hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
        this.hasWarning = false; // this will be a flag for displaying warning messages on the sidebar
        this.hasAllFrequentFlyerPassenger = true; // this will be utilized to identify whether the PNR contains partial or all frequent flyer
        this.IfAllPassengersAreChildren = false;
        this.hasIssuedTicket = true; // used for checking if PNR has issued ticket/s
        this.isFlagged = false;
        this.isMYB = false;
        this.isBookingView = false;
        this.isReviewTTTCompletion = false;
        if (this.router.url.includes('/my-bookings/view/'))
            this.isBookingView = true;
        if (this.router.url.includes('/review-your-trip/deeplink/'))
            this.isReviewTTTCompletion = true;
        if (this.router.url.includes('/my-bookings/'))
            this.isMYB = true;
    }
    INDRADetailsFastTrackComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
        this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
        this.passengers = this.bookingService.INDRA_getPaxInfo();
        this.flightRouteInput = this.INDRA_getFlightRoute();
        this.brandDescription = this.INDRA_getBrandDescription();
        this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
        this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();
        this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK;
        this.paxFareInfoFeatures = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, this.flight.idFlight.toString());
        this.paxTierBenefits = this.bookingService.INDRA_getPassengersTierBenefits(ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK);
        var purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, this.flight.idFlight.toString(), this.flightIdentifier);
        this.passengers.forEach(function (pax) {
            var _a, _b;
            var purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(function (object) { return object[pax.idPax]; });
            if (purchasedIndex === -1) {
                _this.paxPurchaseFeatures.push((_a = {},
                    _a[pax.idPax] = [],
                    _a));
            }
            else {
                var paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
                _this.paxPurchaseFeatures.push((_b = {},
                    _b[pax.idPax] = _this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax]),
                    _b));
            }
            if (pax.prm) {
                var deporteePRM = pax.prm.filter(function (prmItem) { return ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type); });
                var medicalAssistancePRM = pax.prm.filter(function (prmItem) { return ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type); });
                var umnrPRM = pax.prm.filter(function (prmItem) { return SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type; });
                if (deporteePRM.length > 0) {
                    _this.hasDeporteeFlag = true;
                }
                if (medicalAssistancePRM.length > 0) {
                    _this.hasMedicalAssistanceFlag = true;
                }
                if (umnrPRM.length > 0) {
                    _this.hasUMNRFlag = true;
                }
            }
            if (!pax.FFid || !pax.FFnum) {
                _this.hasAllFrequentFlyerPassenger = false;
            }
        });
        this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(function (data) {
            if (data) {
                _this.isFlagged = _this.bookingService.INDRA_isUnavailableFlight(_this.flight.idFlight, data);
            }
        });
        this.INDRA_showAddButtonIfFastTrackIsIncludedOrPurchased();
        // fills input for segmented control radio
        for (var i = 0; i < this.flight.listSegment.length; i++) {
            var segment = this.flight.listSegment[i];
            this.stops.push({
                label: segment.departureAirport + '-' + segment.arrivalAirport,
                value: i
            });
        }
        if (!this.selectedStop) {
            this.INDRA_selectedStop(0);
        }
        this.directFlight = this.flight.listSegment.length > 1 ? false : true;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_constructAncillaryListForPurchased = function (list) {
        var _this = this;
        var returnValue = [];
        list.forEach(function (segment) {
            if (segment.ancillaryList[0].unconfirmed) {
                _this.hasWarning = true;
            }
            returnValue.push({
                ancillaryDetail: '',
                segmentId: segment.segmentId,
                unconfirmed: segment.ancillaryList[0].unconfirmed
            });
        });
        return returnValue;
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRADetailsFastTrackComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRADetailsFastTrackComponent.prototype.INDRA_handleClose = function () { this.closeSidebar(); };
    INDRADetailsFastTrackComponent.prototype.INDRA_capitalize = function (str) {
        if (str.length > 0) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        return '';
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_printPassengerName = function (pax) {
        return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_printBrand = function () {
        return this.brandDescription;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_setDepartureLocation = function (stop) {
        if (this.flight && this.flight.listSegment && this.flight.listSegment.length > 0) {
            var departureAirport = this.flight.listSegment[stop].departureAirport;
            this.departureLocation = this.bookingService.INDRA_getLocation(departureAirport).name;
        }
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getAncillaryForPassenger = function (list, idPax) {
        var returnValue;
        var index = list.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (list) {
            var paxAncillary = list[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getPurchasedAncillaryForPassenger = function (idPax) {
        var returnValue = [];
        var index = this.paxPurchaseFeatures.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (this.paxPurchaseFeatures) {
            var paxAncillary = this.paxPurchaseFeatures[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_displaySegmentDeparture = function (segmentId) {
        var returnValue = '';
        var segmentInfo = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
        var segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
        returnValue = this.INDRA_getTranslation(this.INDRA_getTranslationKey('at', 'text')) + ' ' + segmentDeparture.name + ' ' + this.INDRA_getTranslation(this.INDRA_getTranslationKey('airport', 'text'));
        return returnValue;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getGroupLabel = function () {
        var groupList = ANCILLARY_GROUP_FAST_TRACK_LIST;
        return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_GROUP + groupList[0]));
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_showUpgrade = function () {
        // let brand = this.INDRA_printBrand();
        return !(this.brandDescription === BRAND_DESCRIPTION_TOP_EXECUTIVE || this.brandDescription === BRAND_DESCRIPTION_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren || !this.hasIssuedTicket) && !this.isFlagged;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getTitleTranslation = function (lastKey, keyType) {
        var key = this.LOCAL_TRANSLATION_DETAILED_FASTTRACK + keyType + "." + lastKey;
        return this.INDRA_getTranslation(key);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getTranslationKey = function (lastKey, keyType) {
        return this.LOCAL_TRANSLATION_DETAILED_FASTTRACK + keyType + "." + lastKey;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_showAddButtonIfFastTrackIsIncludedOrPurchased = function () {
        var _this = this;
        var listOfIncluded = this.paxFareInfoFeatures;
        var listOfPurchased = this.bookingService.INDRA_getPassengersPurchasedAncillary(ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, this.flight.idFlight.toString(), this.flightIdentifier);
        var ancillaryAvailable = this.bookingService.INDRA_isAncillaryAvailable(EXTRAS_ANCILLARY_FAST_TRACK, this.flightIdentifier);
        listOfIncluded.forEach(function (value) {
            var itemKey = Object.keys(value);
            itemKey.forEach(function (i) {
                if (value[i].includes(SSR_CODE_FAST_TRACK)) {
                    _this.showAdd = false;
                }
            });
        });
        if (this.showAdd) {
            this.showAdd = false;
            listOfPurchased.forEach(function (value) {
                var itemKey = Object.keys(value);
                itemKey.forEach(function (i) {
                    if (!value[i].includes(SSR_CODE_FAST_TRACK) && ancillaryAvailable) {
                        _this.showAdd = true;
                    }
                });
            });
        }
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_upgradeWithCash = function () {
        var activeBookedTrip = this.bfmDataStorage.INDRA_getActiveBookedTrip();
        var link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
        var params = { flight: this.flight.assignedFlightId };
        this.sidebarService.closeSidebar();
        this.bookingService.INDRA_linkRouteData(link, params);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getPassengerTierLabel = function (pax) {
        return this.bookingService.INDRA_getTierKeyLabel(pax);
    };
    INDRADetailsFastTrackComponent.prototype.openFasttrackSidebar = function () {
        this.sidebarService.openSidebar(['fast-track', { flight: this.flightIdentifier }]);
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getFlightRoute = function () {
        /*
         * 	For Fasttrack, Bus and Train segments are ignored.
         */
        var flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
        if (flightRouteInput && flightRouteInput.listSegment) {
            var flightSegments = flightRouteInput.listSegment.filter(function (segment) {
                return (segment.equipment !== EQUIPMENT_CODE_TRAIN && segment.equipment !== EQUIPMENT_CODE_BUS);
            });
            if (flightSegments && flightSegments.length > 0) {
                var newFlightRouteInput = {
                    listSegment: flightSegments,
                    fareFamily: flightRouteInput.fareFamily,
                    idFlight: flightRouteInput.idFlight
                };
                return newFlightRouteInput;
            }
        }
        return flightRouteInput;
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_selectedStop = function (value) {
        this.INDRA_setDepartureLocation(value);
        if (!this.directFlight) {
            this.selectedStop = value;
            this.flightStop = this.flight.listSegment[this.selectedStop];
        }
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_isEligibleWithFastTrack = function () {
        this.isEligibleFlag = false;
        var fareInformation = this.bfmDataStorage.INDRA_getActiveBookedTrip()['fare-information'];
        var flightIdFareInformation = fareInformation[this.flight.idFlight];
        var segmentAncillaries = flightIdFareInformation.ancillariesBySegment[this.flightStop.idInfoSegment];
        if (segmentAncillaries) {
            this.isEligibleFlag = segmentAncillaries.includes(SSR_CODE_FAST_TRACK);
        }
        return this.isEligibleFlag;
    };
    INDRADetailsFastTrackComponent.prototype.ngOnDestroy = function () {
        if (this.totalSummarySubscription)
            this.totalSummarySubscription.unsubscribe();
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_printImage = function () {
        var IMAGE = 'fast_track.jpg';
        return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
    };
    INDRADetailsFastTrackComponent.prototype.INDRA_getBrandDescription = function () {
        if (this.isBookingView || this.isReviewTTTCompletion) {
            if (!this.flight.fareFamily)
                return '';
            var brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
            return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
        }
        else {
            this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
        }
    };
    return INDRADetailsFastTrackComponent;
}());
export { INDRADetailsFastTrackComponent };
